var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70743 5.46276V16.2583C6.55029 15.9623 5.22254 16.0363 4.15441 16.4506C1.81787 17.3534 0.0599049 20.1207 0.838751 21.9927C1.70661 24.0793 5.59342 24.6786 7.97447 23.1248C9.13903 22.3626 10.2294 20.8902 10.3333 19.4325H10.3481V11.5819L20.5992 8.31147V12.1813C19.442 11.8853 18.1143 11.9593 17.0462 12.3737C14.7096 13.2764 12.9517 16.0437 13.7305 17.9157C14.5984 20.0023 18.4852 20.6016 20.8662 19.0478C22.0308 18.2857 23.1212 16.8132 23.225 15.3556H23.2398V0.62365C23.2398 0.201893 22.8245 -0.101476 22.4239 0.0317104L8.43436 4.47866C8.00414 4.61185 7.71485 5.0114 7.71485 5.46276H7.70743ZM20.5918 5.54415L10.3407 8.81462V6.63924L20.5918 3.36877V5.54415Z",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("title", null, "Music Note")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMusic);
export default __webpack_public_path__ + "static/media/map_music.f2557c6f.svg";
export { ForwardRef as ReactComponent };